/**
 * ButtonCard component
 * @returns <ButtonCard />
 */
import { useState } from "react"

const ButtonCard = ({ card, isSelected, error, clicked, disabled }) => {

    return (
        <>
            <button className={`btn-card ${isSelected ? "--selected" : ""} ${disabled ? "--disabled" : ""}`} onClick={clicked} type="button" disabled={disabled}>
                <div className="left">
                    <p className="name">{card.name}</p>
                    <p className="fw-300 salesman">{card.salesman}</p>
                </div>

                <div className="right">
                    <p>{card.address} | {card.phone}</p>
                    <p>{card.open_hours}</p>
                </div>
            </button>

            {error && <p className="error">{error}</p>}
        </>
    )
}

export default ButtonCard